import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SurveyLanguageInfoFragment = { id: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, lastContentEditTimeAt?: string | null, languageType?: Types.LanguageEnum | null, defaultLanguageType?: Types.LanguageEnum | null, isLocalizedContent: boolean, sourceContentSyncedAt?: string | null, languageConfigs?: Array<{ contentId: string, languageType: Types.LanguageEnum, jobStatus?: Types.JobEntityStatusEnum | null, jobScheduleId?: string | null }> | null, sourceContent?: { id: string, lastContentEditTimeAt?: string | null, languageType?: Types.LanguageEnum | null, defaultLanguageType?: Types.LanguageEnum | null, languageConfigs?: Array<{ contentId: string, languageType: Types.LanguageEnum }> | null } | {} | null };


export type SurveyLanguageInfoFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type SurveyLanguageInfoQueryVariables = Types.Exact<{
  contentId: Types.Scalars['String']['input'];
}>;


export type SurveyLanguageInfoQuery = { content?: { __typename: 'ArticleContentType' } | { __typename: 'BaseResourceSchema' } | { __typename: 'CheckinType' } | { __typename: 'CourseContentType' } | { __typename: 'ExerciseType' } | { __typename: 'ExternalContentType' } | { __typename: 'ExternalEventContentType' } | { __typename: 'HomeworkType' } | { __typename: 'KnowledgeAssetContentType' } | { __typename: 'LiveEventContentType' } | { __typename: 'MicroLearningContentType' } | { __typename: 'OfflineEventContentType' } | { __typename: 'PathContentType' } | { __typename: 'QuizContentType' } | { __typename: 'RecurringExternalEventContentType' } | { __typename: 'RecurringLiveEventContentType' } | { __typename: 'RecurringOfflineEventContentType' } | { __typename: 'RoleplayContentType' } | { __typename: 'ScormContentType' } | { __typename: 'SurveyContentType', id: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, lastContentEditTimeAt?: string | null, languageType?: Types.LanguageEnum | null, defaultLanguageType?: Types.LanguageEnum | null, isLocalizedContent: boolean, sourceContentSyncedAt?: string | null, languageConfigs?: Array<{ contentId: string, languageType: Types.LanguageEnum, jobStatus?: Types.JobEntityStatusEnum | null, jobScheduleId?: string | null }> | null, sourceContent?: { id: string, lastContentEditTimeAt?: string | null, languageType?: Types.LanguageEnum | null, defaultLanguageType?: Types.LanguageEnum | null, languageConfigs?: Array<{ contentId: string, languageType: Types.LanguageEnum }> | null } | {} | null } | { __typename: 'TaskContentType' } | null };

export const SurveyLanguageInfoFragmentDoc = /*#__PURE__*/ gql`
    fragment SurveyLanguageInfo on SurveyContentType {
  id
  type
  status
  lastContentEditTimeAt
  languageType
  defaultLanguageType
  languageConfigs {
    contentId
    languageType
    jobStatus
    jobScheduleId
  }
  isLocalizedContent
  sourceContent {
    ... on SurveyContentType {
      id
      lastContentEditTimeAt
      languageType
      languageConfigs {
        contentId
        languageType
      }
      defaultLanguageType
    }
  }
  sourceContentSyncedAt
}
    `;
export const SurveyLanguageInfoDocument = /*#__PURE__*/ gql`
    query surveyLanguageInfo($contentId: String!) {
  content(filters: {id: $contentId}) {
    __typename
    ... on SurveyContentType {
      ...SurveyLanguageInfo
    }
  }
}
    ${SurveyLanguageInfoFragmentDoc}`;

export function useSurveyLanguageInfoQuery(options: Omit<Urql.UseQueryArgs<SurveyLanguageInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<SurveyLanguageInfoQuery, SurveyLanguageInfoQueryVariables>({ query: SurveyLanguageInfoDocument, ...options });
};